import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const fetchJourneys = createAsyncThunk(
  "journey/fetchJourneys",
  async (thingId, { rejectWithValue }) => {
    try {
      const sessionToken = localStorage.getItem("token");
      if (!sessionToken) throw new Error("No session token found");

      // 🔑 API expects ?{thingId} format, not ?thingId=...
      const response = await axios.get(
        `https://v3.dhundhoo.com/journey/get/${thingId}`,
        {
          headers: { "X-dhundhoo-session": sessionToken },
        }
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
